import React, { useState } from "react";
import { Table } from "antd";
import { Label } from "reactstrap";
import { useSelector } from "react-redux";
import moment from "moment-jalaali";

import { gql, useMutation, useQuery } from "@apollo/client";
import { error } from "../../../../Controllers/toast";
import dayjs from "dayjs";
import Loader from "../../../../Loader";
import LineRangePicker from "./LineRangePicker";

const GET_LINE_EVENTS = gql`
  query Gateway(
    $Gateway_id: Int!
    $PO_id: [Int]
    $dates: [Date]
    $skip: Int
    $offset_date: Int
  ) {
    GetLineEvents(
      Gateway_id: $Gateway_id
      dates: $dates
      offset_date: $offset_date
      skip: $skip
      PO_id: $PO_id
    ) {
      gateway_count
      po_count
      gateway_Event {
        Gateway_id
        event_code
        event_time
        description
        Event_Description {
          content
          event_code
          title
        }
      }
      po_Event {
        PO_id
        event_time
        event_code
        description
        Event_Description {
          title
          event_code
          content
        }
      }
    }
  }
`;

const EventsTab = ({ dateHOC, optimizers_id, Gateway_id, optimizers }) => {
  const [eventsData, setEventsData] = useState([]);
  const [currentDate, setCurrentDate] = useState(dateHOC);
  const [total, setCount] = useState(0);
  const lang_choiced = useSelector((state) => state.lang_change);

  // console.log(currentDate , dateHOC , "is EventsTab")

  const { data, loading, refetch } = useQuery(GET_LINE_EVENTS, {
    // fetchPolicy: 'no-cache',
    variables: {
      dates: dateHOC,
      Gateway_id,
      PO_id: optimizers_id,
      offset_date: new Date().getTimezoneOffset(),
    },
    onCompleted: (res) => {
      // console.log(res , 'is response');
      const events = [
        ...res.GetLineEvents.gateway_Event,
        ...res.GetLineEvents.po_Event,
      ];
      events.sort((a, b) => b.event_time - a.event_time);
      // console.log(events)
      setEventsData(events);
      // console.log(optimizers)
      setCount(res.GetLineEvents.gateway_count + res.GetLineEvents.po_count);
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی رخ داده است!");
    },
  });

  const columns = [
    // {
    //   title:
    //     lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table
    //       .serial_number,
    //   dataIndex: "",
    //   width: 150,
    //   render: (text) => {
    //     return (
    //       <span className="ltr">
    //         {text.PO_id
    //           ? optimizers.filter((device) => device.PO_id === text.PO_id)
    //               .serial_number
    //           : ""}
    //       </span>
    //     );
    //   },
    //   className: "ltr",
    // },
    {
      title:
        lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table
          .event_time,
      dataIndex: "event_time",
      width: 150,
      render: (text) => {
        return (
          <span className="ltr">
            {moment(new Date(text)).format("jYYYY-jMM-jDD HH:mm:ss")}
          </span>
        );
      },
      className: "ltr",
    },
    {
      title:
        lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table
          .event_title,
      dataIndex: "Event_Description",
      render: (text) => text.title,
      width: 250,
    },
    {
      title:
        lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table
          .event_description,
      // dataIndex: "",
      render: (text) => (
        <span>
          {text.Event_Description.content}
          {text.description ? ` (${text.description})` : ""}
        </span>
      ),
      width: 350,
    },
    {
      title:
        lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.table
          .event_code,
      dataIndex: "event_code",

      width: 120,
      // defaultSortOrder: "descend",
      sorter: (a, b) => parseInt(a.repair_code) - parseInt(b.repair_code),
    },
  ];

  if (loading)
    return (
      <div className="animated fadeIn">
        <Loader />
      </div>
    );
  return (
    <div>
      <div key={3}>
        <strong style={{ color: "red" }}>
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.tip}
        </strong>
        <Label color="danger">
          {lang_choiced.pages.byPanel.PanelGroup.Line.Modal.eventTab.tipText}
        </Label>
      </div>
      <div className="text-center mb-2">
        <LineRangePicker
          setDatesHOC={(date) => {
            // console.log(
            //   date,
            //   "date change",
            //   dayjs(
            //     new Date(moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD")),
            //     { jalali: true }
            //   )
            // );
            setCurrentDate([
              moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
              moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
            ]);
            // console.log(powerOptimizer);
            refetch({
              Gateway_id,
              dates: [
                moment(date[0], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
                moment(date[1], "jYYYY-jMM-jDD").format("YYYY-MM-DD"),
              ],
              PO_id: optimizers_id,
              offset_date: new Date().getTimezoneOffset(),
            });
          }}
          dateHOC={dateHOC}
        />
      </div>
      <Table
        striped
        bordered
        small
        hover
        size="small"
        columns={columns}
        dataSource={eventsData}
        pagination={{
          pageSize: 10,
          onChange: (page, pageSize) => {
            // refetch({
            //   dates: currentDate,
            //   Gateway_id,
            //   PO_id: optimizers_id,
            //   offset_date: new Date().getTimezoneOffset(),
            // });
          },
          total: total,
        }}
        rowKey={(record) => record.event_time*Math.random()}
        style={{ overflowX: "auto" }}
      />
    </div>
  );
};

export default React.memo(EventsTab);
